import _ from 'lodash'
import UAParser from 'ua-parser-js'
import Cookies from 'js-cookie'

import api from './api'
import limit from './limit'
import me from './me'

import {version, name} from '../../package.json'

import {pathToUserAccount} from '@/util.js'

export let UA = new UAParser()

export const modules = {
  api,
  limit,
  me
}

export const state = {
  version,
  name,
  env: window.location.hostname.match('dartcome.com') ? 'prod' : 'dev',
  debug: process.env.NODE_ENV !== 'production',
  ua: UA.getResult(),
  localBaseUrl: 'http://localhost/nutspie/dartcome-web',
  vo: {
    sid: 'sid' // ranch tephra-session-id
  }
}

export const getters = {
  // is
  isMobile: state => {
    let isMobile = state.ua.device.type === 'mobile'
    if (window.innerWidth <= 480) { // 要跟 index.css 保持同步
      isMobile = true
    }
    return isMobile
  },
  isChrome: state => state.ua.browser.name === 'Chrome',
  isWeChat: state => state.ua.browser.name === 'WeChat',
  isApp: state => {
    const isApp = !!(state.ua.ua.match(/NUTSAPP/))
    return isApp
  },
  // href
  pageAccount: () => pathToUserAccount(location.pathname),
  rootDomain: state => state.env === 'prod' ? 'com' : 'nutsb.com',
  baseDomain: (state, getters) => `dartcome.${getters.rootDomain}`,
  imgUrl: (state, getters) => `https://img.dartcome.${getters.rootDomain}`,
  downloadUrl: (state, getters) => {
    if (getters.isMobile) {
      return `https://download.nutsbp.${getters.rootDomain}`
    }
    return `https://m.nutsbp.${getters.rootDomain}`
  },
  editorUrl: (state, getters) => `https://bp.nutsbp.${getters.rootDomain}`,
  editorUrlSignup: (state, getters) => `${getters.editorUrl}/signUp`,
  editorUrlForget: (state, getters) => `${getters.editorUrl}/Forget`
}

export const actions = {
  async setCookie ({state, getters, dispatch}, {path = null, value}) {
    if (path === null && typeof value === 'object') {
      for (let k of Object.keys(value)) {
        dispatch('setCookie', {path: k, value: value[k]})
      }
      return
    }
    // 需要特殊處理
    let vo = state.vo
    if (vo[path]) {
      Cookies.set(vo[path], value, {domain: `.${getters.baseDomain}`})
      Cookies.set(vo[path], value, { domain: `localhost` })
    }
  },
  async get ({state}, {path = null} = {}) {
    let data = {}
    let json = localStorage.getItem(state.name)
    if (json) {
      try {
        data = JSON.parse(json)
      } catch (e) {
        data = {}
      }
    }
    if (!path) {
      return data
    }
    let v = _.get(data, path, null)
    let vo = state.vo
    // 需要特殊處理
    if (!v && vo[path]) {
      v = Cookies.get(vo[path])
    }
    return v
  },

  /**
   * set
   * @param {string} path null 指的是 整个覆盖
   * @param {any} value
   */
  async set ({state, dispatch}, {path = null, value} = {}) {
    let data = await dispatch('get')
    if (path) {
      _.set(data, path, value)
    } else {
      data = value
    }
    localStorage.setItem(state.name, JSON.stringify(data))
    dispatch('setCookie', {path, value})
  },

  /**
   * merge
   * @param {string} path null 指的是 整个合併
   * @param {any} value
   */
  async merge ({state, dispatch}, {path = null, value} = {}) {
    let data = await dispatch('get')
    if (path) {
      let partial = await dispatch('get', {path})
      _.set(data, path, _.merge(partial, value))
    } else {
      data = _.merge(data, value)
    }
    localStorage.setItem(state.name, JSON.stringify(data))
    dispatch('setCookie', {path, value})
  },
  clear ({state, getters}) {
    let vo = state.vo
    Object.keys(vo).forEach(k => {
      Cookies.remove(k, {domain: `.nutsb.com`}) // old dev env
      Cookies.remove(k, {domain: `.${getters.baseDomain}`}) // old prod env
      Cookies.remove(k)

      Cookies.remove(vo[k], {domain: `.nutsb.com`})
      Cookies.remove(vo[k], {domain: `.${getters.baseDomain}`})
      Cookies.remove(vo[k])
    })
    localStorage.clear()
  },
  checkFile ({rootState, rootGetters}, {file}) {
    if (!file || !file.type) {
      throw new Error('请选择正确格式')
    }
    if (file.size > rootGetters['limit/fileMaxSize']) {
      throw new Error(`档案尺寸超出 ${rootState.limit.fileMaxSizeMb}MB 上限`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/store.js